import React from 'react';
import SectionWrapper from './SectionWrapper';
import ProcessList from './ProcessList';

const ProcessSection = ({ 
  section, 
  className = '',
  titleTag = 'h4',
  showContent = false,
  showSubtitle = false
}) => {
  if (!section) return null;

  // Handle complex sections with multiple lists (like CBT methodology)
  if (section.lists && section.lists.length > 0) {
    return (
      <SectionWrapper className={className}>
        <h4>{section.title}</h4>
        {showSubtitle && section.subtitle && <span>{section.subtitle}</span>}
        {section.lists.map((list, listIndex) => (
          <div key={listIndex}>
            {list.subtitle && <span>{list.subtitle}</span>}
            <ul>
              {list.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </SectionWrapper>
    );
  }

  // Handle sections with content and items
  if (section.content && section.items) {
    return (
      <SectionWrapper className={className}>
        <h4>{section.title}</h4>
        <span>{section.content}</span>
        <ul>
          {section.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </SectionWrapper>
    );
  }

  // Handle simple sections with just items
  return (
    <ProcessList 
      section={section} 
      className={className}
      wrapperClassName={className}
      showContent={showContent}
    />
  );
};

export default ProcessSection;